import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabbedScrollerComponent } from './tabbed-scroller/tabbed-scroller.component';
import { ViewMode } from '@/app/components/shared/view-switcher/view-switcher.enum';

@Component({
  standalone: true,
  imports: [TabbedScrollerComponent, CommonModule],
  selector: 'app-project-stages',
  templateUrl: './project-stages.component.html',
  styleUrls: ['./project-stages.component.css'],
})
export class ProjectStagesComponent {
  ViewMode = ViewMode;

  templateMode: ViewMode = ViewMode.TABBED;
}
